import { actionNameGenerator } from "../../../utils/commonUtil";

const domainPrefix = "As"; // AS stands for ACCOUNT SUMMARY
const AsActionNameGenerator = actionNameGenerator(domainPrefix);

export const fetchAccountSummaryDataType = AsActionNameGenerator('fetchAccountSummaryData');
export const fetchBotDataType = AsActionNameGenerator('fetchBotData');
export const fetchAccountDataType = AsActionNameGenerator('fetchAccountData');

export const fetchAccountDataSuccessType = AsActionNameGenerator('fetchAccountDataSuccess');

export const fetchOtherTransactionDataType = AsActionNameGenerator('fetchOtherTransactionData');

export const fetchOtherTransactionDataSuccessType = AsActionNameGenerator('fetchOtherTransactionDataSuccess');

export const fetchInvestmentDataType = AsActionNameGenerator('fetchInvestmentData');

export const fetchInvestmentDataSuccessType = AsActionNameGenerator('fetchInvestmentDataSuccess');

export const fetchGrantsDataType = AsActionNameGenerator('fetchGrantsData');

export const fetchGrantsDataSuccessType = AsActionNameGenerator('fetchGrantsDataSuccess');

export const fetchContributionDataType = AsActionNameGenerator('fetchContributionData');

export const fetchContributionDataSuccessType = AsActionNameGenerator('fetchContributionDataSuccess');

export const fetchAccountSummaryBalanceDataType = AsActionNameGenerator('fetchAccountSummaryBalanceData');

export const fetchAccountSummaryBalanceDataSuccessType = AsActionNameGenerator('fetchAccountSummaryBalanceDataSuccess'); 

export const fetchAllAccountSummaryDataType = AsActionNameGenerator('fetchAllAccountSummaryData');

export const fetchAllAccountSummaryDataSuccessType = AsActionNameGenerator('fetchAllAccountSummaryDataSuccess');

export const fetchAccountSummaryBot3YrType = AsActionNameGenerator('fetchAccountSummaryBot3Yr');

export const fetchMyAccountDataType = AsActionNameGenerator('fetchMyAccountData');

export const fetchMyAccountDataSuccessType = AsActionNameGenerator('fetchMyAccountDataSuccess');